import { render, staticRenderFns } from "./PowraTitle.vue?vue&type=template&id=4f5b8a5d&scoped=true&"
import script from "./PowraTitle.vue?vue&type=script&lang=js&"
export * from "./PowraTitle.vue?vue&type=script&lang=js&"
import style0 from "./PowraTitle.vue?vue&type=style&index=0&id=4f5b8a5d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b8a5d",
  null
  
)

export default component.exports